import { render, staticRenderFns } from "./QuickAdd.vue?vue&type=template&id=10f849c4&scoped=true&"
import script from "./QuickAdd.vue?vue&type=script&lang=js&"
export * from "./QuickAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuickAdd.vue?vue&type=style&index=0&id=10f849c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f849c4",
  null
  
)

export default component.exports